import { RolesRightsService } from './../../business-services/roles-rights.service';
import { UrlTree, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class EditRoleRightsGuard  {

    constructor(
        private rolesRightsService: RolesRightsService,
        private router: Router
    ) { }

    canActivate(): Promise<UrlTree | boolean> | Observable<UrlTree | boolean> | UrlTree | boolean {
        if (this.rolesRightsService.selectedRole) return true;
        return this.router.createUrlTree(['/roles-rights']);
    }
}